import * as React from 'react'

export default () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.47368 6.89685C8.15768 4.67276 11.4363 4.4711 13.3709 6.48104V6.48104C13.7144 6.83791 14.2856 6.83791 14.6291 6.48104V6.48104C16.5637 4.4711 19.8423 4.67276 21.5263 6.89685V6.89685C22.4453 8.11051 22.6996 9.7068 22.1995 11.1446L21.1328 14.2114L18.8337 22.0169C18.4126 23.4465 16.3873 23.4456 15.9675 22.0155L14.5375 17.1441C14.38 16.6076 13.62 16.6076 13.4625 17.1441L12.0325 22.0155C11.6127 23.4456 9.58742 23.4465 9.16631 22.0168L6.86722 14.2114L5.8005 11.1446C5.30039 9.7068 5.55474 8.11051 6.47368 6.89685V6.89685Z"
      stroke="#8FB4FF"
      strokeWidth="2"
    />
    <rect
      x="11.8126"
      y="9.73833"
      width="4.35978"
      height="4.35978"
      rx="0.544972"
      fill="#8FB4FF"
      stroke="#8FB4FF"
      strokeWidth="1.08994"
    />
    <path d="M6.63477 11.9185H21.349" stroke="#8FB4FF" strokeWidth="1.63492" />
  </svg>
)
